<div id="report-nav-menu" class="d-flex justify-content-center">
  <ul class="report-nav-ul">
    <ng-container *ngFor="let option of menuOptions">
      <li class="report-nav-li pointer-cursor">
        <a [routerLink]="['../' + option.fileName]">
          <div class="card report-nav-sub-menu" [class.report-nav-disabled]="(activeLink == option.fileName)" style="border: none; border-radius: 0;">
            <div class="card-body text-center" style="padding: 0.5rem; padding-bottom: 0;">
              <div class="datasheet-icons-menu">
                <img src="/assets/icons/{{option.fileName}}.svg" alt="{{option.alt}}" />
              </div>
              <p class="datasheet-title-menu">{{option.label}}</p>
            </div>
          </div>
        </a>
      </li>
    </ng-container>
  </ul>
</div>
